// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';
import type {AsyncAction} from 'redux/types';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const DELETE_TRAVELERS = 'v1/travelers/delete/DELETE_TRAVELERS';

export type DeleteTravelersSuccess = ApiSuccess<*, {}>;

export function deleteTravelers(journeyId: number, token: string): AsyncAction {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };

  return {
    types: ASYNC_TYPES(DELETE_TRAVELERS),
    callAPI: () =>
      axios
        .delete(`${cfg.bookingServiceUrl}/traveller/${journeyId}`, config)
        .then(() => ({})),
  };
}
